<script lang="ts">
    import { onMount, getContext } from "svelte";
    import { Link, navigate } from "svelte-navigator";
    import moment from "moment";
    import { api, loader, swClient, toast, user } from "../stores";

    import ExportUb from "./ExportUB.svelte";
    import ConfirmPopup from "../modals/ConfirmPopup.svelte";
    import DocumentDetailModal from "../modals/DocumentDetailModal.svelte";
    import SearchFilterComponent from "../admin/components/SearchFilterComponent.svelte";
    import { Campaign, Order, Types } from "../model";

    let documentsDiv;
    let last_scroll = 0;
    let showedItems = 15;
    let documents = [];
    let allDocuments = [];
    let allCampaigns = [];
    let shop_id = null;
    let userType = null;
    let userSca = null;
    let shop_orders: Order[] = [];

    const { open, close } = getContext("simple-modal");

    onMount(async () => {
        await getDocuments();
    });

    async function getDocuments() {
        const processIdGetCamp = $loader.show("Chargement des opérations");
        allDocuments = [];
        allCampaigns = [];
        documents = [];
        $swClient.getCampaigns().then(
            (SWCampaigns: Campaign[]) => {
                allCampaigns = SWCampaigns;
                const processId = $loader.show("Chargement des documents");
                $swClient.getDocuments().then(
                    (res) => {
                        allDocuments = res.map((d) => formatDocument(d));
                        $loader.hide(processId);
                    },
                    (err) => {
                        console.error(err);
                        $loader.hide(processId);
                    }
                );
                $loader.hide(processIdGetCamp);
            },
            (err) => {
                console.error(err);
                $loader.hide(processIdGetCamp);
            }
        );
    }

    function formatDocument(item) {
        let doc: any = {
            uid: item.uid,
            name: item.name,
            geo_area: item.geo_area,
            categories: item.categories,
            campaignUid: item.campaign_uid,
        };
        for (let j = 0; j < item.document_milestones.length; j++) {
            const milestone = item.document_milestones[j];
            if (milestone.name === "Début") {
                doc.startDate = milestone.date;
            }
            if (milestone.name === "Fin") {
                doc.endDate = milestone.date;
            }
        }

        let iCampaign = allCampaigns.find((e) => e.uid === item.campaign_uid);
        doc.campaign_type_name = iCampaign.type.name;

        return doc;
    }

    function importPDF(e, document_uid) {
        const loaderId = $loader.show(
            "Votre pdf est en cours d'import, merci de patienter quelques instants, l'opération peut prendre plusieurs minutes..."
        );
        $api.postPdfImport(document_uid, e.target.files[0], $swClient.token)
            .then(async () => {
                $toast.success("Votre pdf a été importé avec succès");
            })
            .catch((e) => {
                $toast.error(
                    `Une erreur s'est produite, l'import ne s'est pas exécuté correctement.`,
                    10000
                );
                console.error(e);
            })
            .finally(() => {
                $loader.hide(loaderId);
            });
    }

    async function onShowProducts(document_uid) {
        navigate("/admin/products/" + document_uid);
    }

    function openDetailModal(document) {
        open(DocumentDetailModal, {
            document: document,
            onShowProducts: onShowProducts,
        });
    }

    async function wheelEvent(event) {
        if (event.deltaY > 0) {
            showedItems++;
        }
    }

    async function handle_scroll(event) {
        if (documentsDiv.scrollTop > last_scroll) {
            showedItems++;
        }
        last_scroll = documentsDiv.scrollTop;
    }
</script>

<div
    class="wrapper"
    bind:this={documentsDiv}
    on:wheel={wheelEvent}
    on:scroll={handle_scroll}
>
    <div class="sticky-menu">
        <SearchFilterComponent
            listToFilter={allDocuments}
            bind:filteredList={documents}
            scope="document"
        />
        {#if documents.length > 0}
            <div class="header campaign-line columns header">
                <div class="campaign-case column">Opération</div>
                <div class="campaign-case column">Import PDF</div>
                <div class="campaign-case column">Produits</div>
                <div class="campaign-case column">Détails</div>
            </div>
        {/if}
    </div>
    {#if documents.length > 0}
        {#each documents as document, i}
            {#if i < showedItems}
                <div
                    class="campaign-line columns {i % 2 === 0
                        ? 'bg-white'
                        : ''}"
                >
                    <div class="campaign-case column">
                        {document.name}
                    </div>
                    <div class="campaign-case column">
                        <label class="button is-dark btn-file">
                            <input
                                type="file"
                                accept=".pdf"
                                on:change={(e) => {
                                    importPDF(e, document.uid);
                                }}
                            />
                            Import PDF
                        </label>
                    </div>
                    <div class="campaign-case column">
                        <button
                            class="button is-dark btn-elpev"
                            on:click={() => {
                                onShowProducts(document.uid);
                            }}
                        >
                            Voir les produits
                        </button>
                    </div>
                    <div class="campaign-case column">
                        <button
                            class="button btn-elpev"
                            on:click={() => openDetailModal(document)}
                        >
                            <i class="fas fa-info" />
                        </button>
                    </div>
                </div>
            {/if}
        {/each}
    {:else}
        <h1>Aucune version disponible</h1>
    {/if}
</div>

<style lang="scss">
    @import "../styles/variables.scss";

    .campaign-line {
        border-radius: 12px;
    
        &.bg-white {
            background-color: white;
        }

        &:not(.header) {
            border: 1px solid $grey-light;
            &:hover {
                filter: drop-shadow(0px 2px 8px $light-lavender);
            }
        }
    }

    .btn-file {
        background-color: $dark-black;
        border-radius: 10px;

        input[type="file"] {
            display: none;
        }
    }

    .sticky-menu {
        top: 0px;
        position: sticky;
        top: -1.25rem;
        margin-bottom: 24px;
        z-index: 999;
    }

    .header {
        background-color: $beige;
        border-radius: 12px;
        .campaign-case {
            color: black;
            font-weight: 900 !important;
            font-family: "Gilmer Bold" !important;
        }
    }
    .columns {
        margin-left: 0;
        margin-right: 0;
    }
</style>
